import React, { useState, useEffect } from 'react';
import {
  ActionBarRiskDivisionComp,
  DatatableRiskDivisions,
  CreateRiskDivisionComp,
  EditRiskDivisionComp,
} from '../../components';
import Modal from 'react-bootstrap/Modal';
import axios from '../../library/axios';
import { MySwal } from '../../library/swal';
import { useLocation } from 'react-router-dom';
import { validationAccess } from "../../helpers/validationAccess"
import { getModule, setHrefWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";
import { notifyApiError, notifyApiLoadError } from '../../helpers/notifyApiError';

const RiskDivisionsPage = () => {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);
  const [search, setSearch] = useState([]);
  const [filterDivisions, setFilterDivisions] = useState([]);
  const [editRiskDivision, seteditRiskDivision] = useState({});
  const [lgShowAdd, setLgShowAdd] = useState(false);
  const [lgShowUpdate, setLgShowUpdate] = useState(false);

  const [divisions, setDivisions] = useState([]);

  const fetchDataDivisions = async () => {
    try {
      const options = {
        url: `/risk-divisions/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      // return false
      setDivisions(data);
      setFilterDivisions(data);
    } catch (err) {
      notifyApiLoadError(err, 'pages/risk-divisions/index.fetchDataDivisions');
    }
  };

  const handleHapusDivision = (id) => {
    MySwal.fire({
      title: 'Apa anda yakin menghapus data ini?',
      text: 'Anda tidak akan dapat mengembalikan data ini!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus Data!',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
          },
        };

        axios
          .delete(`/risk-divisions/delete/${id}`, config)
          .then((res) => {
            // console.log(res)
            // return false
            if (res.status === 200) {
              MySwal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Hapus Divisi Berhasil!',
              });
              // return false
              setTimeout(() => {
                fetchDataDivisions();
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== '') {
            notifyApiError(err, { context: 'pages/risk-divisions/index.handleHapusDivision' });
              // err({ err: err?.response?.data || err });
            }
          });
      }
    });
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook("/login");
        }, 3000);
      } else {
        // console.log(data?.data?.mapping_groups[0].module.pathModule)
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname === mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook("/login");
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'pages/risk-divisions/index.fetchLoginStatus');
    }
  };

  useEffect(() => {
    fetchDataDivisions();
    fetchLoginStatus();
  }, []);

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  const handleEditDivision = (editRiskDivision) => {
    seteditRiskDivision(editRiskDivision);
    setLgShowUpdate(true);
  };

  useEffect(() => {
    const result = divisions.filter((item) => {
      let namaDivision = item.namaDivision;
      return namaDivision.toLowerCase().match(search.toString().toLowerCase());
    });
    setFilterDivisions(result);
  }, [search]);

  // console.log(modules);
  return (
    <>
      {/*begin::Content*/}
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        {/*begin::Toolbar*/}
        <div className="toolbar" id="kt_toolbar">
          {/*begin::Container*/}
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            {/*begin::Page title*/}
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              {/*begin::Title*/}
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Halaman Unit Kerja Manajemen Risiko
                {/*begin::Separator*/}
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                {/*end::Separator*/}
                {/*begin::Description*/}
                <small className="text-muted fs-7 fw-bold my-1 ms-1">
                  #SPEAK_VERSI_RS
                </small>
                {/*end::Description*/}
              </h1>
              {/*end::Title*/}
            </div>
            {/*end::Page title*/}
            {/*begin::Actions*/}
            <ActionBarRiskDivisionComp showFormAdd={() => setLgShowAdd(true)} />
            {/*end::Actions*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Toolbar*/}
        {/*begin::Post*/}
        <div className="post d-flex flex-column-fluid" id="kt_post">
          {/*begin::Container*/}
          <div id="kt_content_container" className="container-xxl">
            {/*begin::Row*/}
            <div className="row gy-5 g-xl-8">
              {/*begin::Col*/}
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <DatatableRiskDivisions
                      listDivisions={filterDivisions}
                      search={search}
                      handleChangeSearch={handleChangeSearch}
                      handleEditDivision={handleEditDivision}
                      handleHapusDivision={handleHapusDivision}
                    />
                  </div>
                </div>
              </div>
              {/*end::Col*/}
            </div>
            {/*end::Row*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Post*/}
      </div>
      {/*end::Content*/}

      <Modal
        show={lgShowAdd}
        onHide={() => setLgShowAdd(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Tambah Divisi </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateRiskDivisionComp
            close={() => setLgShowAdd(false)}
            fetch={() => fetchDataDivisions()}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowUpdate}
        onHide={() => setLgShowUpdate(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Divisi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditRiskDivisionComp
            editRiskDivision={editRiskDivision}
            close={() => setLgShowUpdate(false)}
            fetch={() => fetchDataDivisions()}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RiskDivisionsPage;
